import { authConfigStore } from "@amzn/aquila-feedback-web-assets";
import type { Stage } from "@amzn/aquila-service-type-script-client";
import { getUsername } from "@amzn/midway-cognito-type-script-provider";

import { getAquilaApiCredentials } from "../api/aquilaApi/aquilaApi";
import { getCdbApiClient } from "../api/cdbApi/cdbApi";
import { getWebsiteSettingsFromConfig } from "../api/websiteSettings";
import { authStore } from "../store/auth";
import { FeatureFlagsStore, getFlagValues } from "../store/featureFlags";
import { salesforceStore } from "../store/salesforce";

import { isTestSiteOrDev } from "./environment.utils";
import {
    getAdvertiserId,
    getSpoofAsUser,
    isValidAdvertiserId,
} from "./permission.utils";

export const startup = async (): Promise<void> => {
    const isValidId = isValidAdvertiserId();
    const settings = getWebsiteSettingsFromConfig();
    authStore.getState().setSettings(settings);
    const asyncCalls = [
        (async () => {
            let username: string = await getUsername();
            const flags = await getFlagValues(username);
            FeatureFlagsStore.getState().setFeatureFlags(flags);
            if (flags.supportMode && getSpoofAsUser() && isTestSiteOrDev()) {
                username = getSpoofAsUser()!;
            }
            authStore.getState().setUsername(username);

            // Set up Aquila Auth Config
            const credentials = await getAquilaApiCredentials();
            authConfigStore.getState().setAuthConfig({
                awsCredentials: {
                    ...credentials,
                    accountId: settings.blinkAwsAccountId,
                },
                stage: settings.stage.toUpperCase() as Stage,
                userAlias: username,
            });
        })(),
        (async () => {
            if (isValidId) {
                const advertiserId = getAdvertiserId();

                try {
                    const { data } = await (
                        await getCdbApiClient()
                    ).getSfContext({
                        advertiserId,
                    });
                    if (data) {
                        salesforceStore.getState().setSfContext(data);
                    }
                } catch (error) {
                    console.error(
                        "Error fetching SfContext with ID:",
                        advertiserId,
                        error,
                    );
                }
            }
        })(),
    ];

    await Promise.all(asyncCalls);
};
